var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafetyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.23,7.63H15.64v-.8a3,3,0,0,0-3-3H11.34a3,3,0,0,0-3,3v.8H5.77A2.18,2.18,0,0,0,3.6,9.8V18a2.17,2.17,0,0,0,2.17,2.16H18.23A2.17,2.17,0,0,0,20.4,18V9.8A2.18,2.18,0,0,0,18.23,7.63ZM10,6.83a1.36,1.36,0,0,1,1.35-1.35h1.32A1.36,1.36,0,0,1,14,6.83v.8H10Zm5.28,7.61H12.82V16.9H11.18V14.44H8.73V12.8h2.45V10.35h1.64V12.8h2.45Z",
    style: {
      fill: "#d45151"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon);
export default __webpack_public_path__ + "static/media/safety_icon.7e2cd5e4fa3e5ac8637c3791f0bf6708.svg";
export { ForwardRef as ReactComponent };